import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-296bac26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col text-center mt-2" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  key: 0,
  class: "col"
}
const _hoisted_10 = {
  key: 1,
  class: "col text-end"
}
const _hoisted_11 = {
  key: 4,
  class: "row"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-center my-2" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" })
  ])
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 5,
  class: "row"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col text-center my-2 text-danger" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Der opstod en fejl, prøv igen senere..")
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 6 }
const _hoisted_18 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_19 = { key: 7 }
const _hoisted_20 = { key: 8 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col text-center" }, [
    /*#__PURE__*/_createTextVNode(" Servicekontrakten er færdig - tryk på \"Gem servicekontrakt\", for at gemme kontrakten."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Når kontrakten er gemt får du mulighed for at Downloade den."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Kontrakten bliver IKKE sendt til underskrift automatisk, du skal selv sende den til underskrift."),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "row mb-5" }
const _hoisted_24 = { class: "col-6 text-start" }
const _hoisted_25 = { class: "col-6 text-end" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 1,
  class: "border border-warning text-start p-3 mt-2"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-warning" }, "[Dev only]", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = { class: "" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Validation:", -1))
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_b_icon_download = _resolveComponent("b-icon-download")!
  const _component_SearchModal = _resolveComponent("SearchModal")!
  const _component_StepProgess = _resolveComponent("StepProgess")!
  const _component_b_icon_search = _resolveComponent("b-icon-search")!
  const _component_Fields = _resolveComponent("Fields")!
  const _component_b_icon_plus = _resolveComponent("b-icon-plus")!
  const _component_Summary = _resolveComponent("Summary")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.restoreDialog.display)
      ? (_openBlock(), _createBlock(_component_ConfirmDialog, {
          key: 0,
          text: _ctx.restoreDialog.text,
          title: _ctx.restoreDialog.title,
          enableX: _ctx.restoreDialog.enableX,
          okBtn: _ctx.restoreDialog.okBtn,
          cancelBtn: _ctx.restoreDialog.cancelBtn,
          onOk: _ctx.restoreDialog.ok,
          onCancel: _ctx.restoreDialog.cancel
        }, null, 8, ["text", "title", "enableX", "okBtn", "cancelBtn", "onOk", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.loadCustomerDialog.display)
      ? (_openBlock(), _createBlock(_component_ConfirmDialog, {
          key: 1,
          text: _ctx.loadCustomerDialog.text,
          title: _ctx.loadCustomerDialog.title,
          enableX: _ctx.loadCustomerDialog.enableX,
          okBtn: _ctx.loadCustomerDialog.okBtn,
          cancelBtn: _ctx.loadCustomerDialog.cancelBtn,
          onOk: _ctx.loadCustomerDialog.ok,
          onCancel: _ctx.loadCustomerDialog.cancel
        }, null, 8, ["text", "title", "enableX", "okBtn", "cancelBtn", "onOk", "onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.contractSavedDialog.display)
      ? (_openBlock(), _createBlock(_component_ConfirmDialog, {
          key: 2,
          text: _ctx.contractSavedDialog.text,
          title: _ctx.contractSavedDialog.title,
          enableX: _ctx.contractSavedDialog.enableX,
          okBtn: _ctx.contractSavedDialog.okBtn,
          enableCancel: false,
          onOk: _ctx.contractSavedDialog.ok
        }, {
          default: _withCtx(() => [
            _createElementVNode("b", null, [
              _createTextVNode("Download Servicekontrakt"),
              (_ctx.serviceContract._contractSavedIds.length > 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_1, "er"))
                : _createCommentVNode("", true)
            ]),
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceContract._contractSavedIds, (contractId, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col text-center",
                  key: i
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-success",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadContract && _ctx.downloadContract(...args)))
                  }, [
                    _createTextVNode(_toDisplayString(contractId) + " ", 1),
                    _createVNode(_component_b_icon_download)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["text", "title", "enableX", "okBtn", "onOk"]))
      : _createCommentVNode("", true),
    (_ctx.customerModal.display)
      ? (_openBlock(), _createBlock(_component_SearchModal, {
          key: 3,
          primaryKey: _ctx.customerModal.primaryKey,
          excludedKeys: _ctx.customerModal.excludedKeys,
          searchPath: _ctx.customerModal.searchPath,
          text: _ctx.customerModal.text,
          title: _ctx.customerModal.title,
          enableX: _ctx.customerModal.enableX,
          okBtn: _ctx.customerModal.okBtn,
          cancelBtn: _ctx.customerModal.cancelBtn,
          onOk: _ctx.customerModal.ok,
          onCancel: _ctx.customerModal.cancel
        }, null, 8, ["primaryKey", "excludedKeys", "searchPath", "text", "title", "enableX", "okBtn", "cancelBtn", "onOk", "onCancel"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_StepProgess, {
          steps: _ctx.serviceContract.steps,
          currentStep: _ctx.serviceContract.currentStep,
          maxStep: _ctx.serviceContract.maxStep,
          onStepClicked: _ctx.goToStep
        }, null, 8, ["steps", "currentStep", "maxStep", "onStepClicked"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h4", null, _toDisplayString(_ctx.serviceContract.getName(_ctx.serviceContract.currentStep)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.serviceContract.currentStep == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.importCustomer && _ctx.importCustomer(...args))),
              class: "btn btn-link",
              id: "findServiceContractCustomer"
            }, [
              _createVNode(_component_b_icon_search),
              _createTextVNode("Indlæs eksisterende kunde")
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.errors && _ctx.ready && _ctx.serviceContract.hasFields && _ctx.$root?.isDebug())
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.autoFill && _ctx.autoFill(...args))),
              class: "btn btn-link text-warning",
              id: "findServiceContractCustomer"
            }, "autofill [Dev only]")
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.ready)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
      : _createCommentVNode("", true),
    (_ctx.ready && _ctx.errors)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
      : _createCommentVNode("", true),
    (!_ctx.errors && _ctx.ready && _ctx.serviceContract.hasFields)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_Fields, { serviceContract: _ctx.serviceContract }, null, 8, ["serviceContract"]),
          (_ctx.serviceContract.canBeArray)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addSection && _ctx.addSection(...args))),
                  class: "btn btn-link"
                }, [
                  _createVNode(_component_b_icon_plus),
                  _createTextVNode("Tilføj " + _toDisplayString(_ctx.serviceContract.getName(_ctx.serviceContract.currentStep)), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.errors && _ctx.ready && _ctx.serviceContract.isCurrentStep('Opsummering'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_Summary, { serviceContract: _ctx.serviceContract }, null, 8, ["serviceContract"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.errors && _ctx.ready && _ctx.serviceContract.isCurrentStep('Underskift'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, [
        (_ctx.serviceContract.currentStep > 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.previousStep()))
            }, _toDisplayString(_ctx.serviceContract.previousStepName), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_25, [
        (_ctx.serviceContract.currentStep < _ctx.serviceContract.totalSteps)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.nextStep())),
              disabled: _ctx.hasFieldErrors
            }, _toDisplayString(_ctx.serviceContract.nextStepName), 9, _hoisted_26))
          : _createCommentVNode("", true),
        (!_ctx.errors && _ctx.ready && _ctx.serviceContract.hasFields && _ctx.$root?.isDebug())
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _hoisted_28,
              _hoisted_29,
              _createElementVNode("div", _hoisted_30, "Current step: " + _toDisplayString(_ctx.serviceContract.currentStep), 1),
              _hoisted_31,
              _hoisted_32,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dev.fieldState, (validated, field) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: 'validated_'+field,
                  class: "row-striped"
                }, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, _toDisplayString(field) + ": ", 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["col-2", {'text-success': validated, 'text-danger': !validated}])
                    }, _toDisplayString(validated), 3)
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.fakeSaved && _ctx.fakeSaved(...args))),
                  type: "button"
                }, "Saved")
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}